import { render, staticRenderFns } from "./CenterSetting.vue?vue&type=template&id=0b21e2e2"
import script from "./CenterSetting.vue?vue&type=script&lang=js"
export * from "./CenterSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports